import { VehicleGroupWithoutStatusOutput } from './vehicle-group-without-status-output.model';


export class VehicleGroupSelectByIdOutput implements IVehicleGroupSelectByIdOutput {
    status!: number;
    message!: string;
    data!: VehicleGroupWithoutStatusOutput;

    constructor(data?: IVehicleGroupSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? VehicleGroupWithoutStatusOutput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleGroupSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleGroupSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IVehicleGroupSelectByIdOutput {
    status: number;
    message: string;
    data: VehicleGroupWithoutStatusOutput;
}

